import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaInicio: moment(new Date()).format('YYYY-MM-DD'),
    fechaFin: moment(new Date()).format('YYYY-MM-DD'),
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    tipoEventoId: 0,
    tipoEvento: null,
    tipoEventoNombre: null,
    nombre: '',
    mensajeTexto: '',
    mensajeRespuesta: '',
    sorteoPuestos: 0,
    
    registroManualHabilitado: false,
    solicitaCodigoPromocion: false,
    requiereCodigoPromocion: false,
    validaCodigoDuplicado: false,
    solicitaNombre: false,
    requiereNombre: false,
    solicitaDocumento: false,
    requiereDocumento: false,
    validaDocumentoDuplicado: false,
    solicitaDatosPersonales: false,
    solicitaTelefono: false,
    requiereTelefono: false,
    validaTelefonoDuplicado: false,
    solicitaEmail: false,
    requiereEmail: false,
    validaEmailDuplicado: false,
    solicitaUbicacion: false,
    requiereUbicacion: false,
    solicitaLocalidad: false,
    requiereLocalidad: false,
    solicitaBarrio: false,
    requiereBarrio: false,
    requiereInformacionBancaria: false,

    participacionNegocios: false,
    solicitaPosicionNegocio: false,
    requierePosicionNegocio: false,
    solicitaRazonSocialNegocio: false,
    requiereRazonSocialNegocio: false,
    solicitaDocumentoNegocio: false,
    requiereDocumentoNegocio: false,
    validaDocumentoNegocioDuplicado: false,
    solicitaUbicacionNegocio: false,
    requiereUbicacionNegocio: false,
    solicitaLocalidadNegocio: false,
    requiereLocalidadNegocio: false,
    solicitaBarrioNegocio: false,
    requiereBarrioNegocio: false,

    importaParticipantes: false,
    sorteaGanadores: false,
    importaGanadores: false,
    validaIdentidad: false,
    validaParticipacion: false,
    validaImagenes: false,
    transferenciasPremios: false,
    rowVersion: null,

    camposAdicionales: [],
    campoAdicional: {},

    participantesColumnas: [],
    
    participantesColumnasList: [],

    importParticipanteId: 0,
    participantesImportados: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state, eventoId) {
        state.id = eventoId;
        state.fechaInicio = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaFin = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.tipoEventoId = 0;
        state.tipoEvento = null;
        state.tipoEventoNombre = null;
        state.nombre = '';
        state.mensajeTexto = '';
        state.mensajeRespuesta = '';
        state.sorteoPuestos = 0;
        state.registroManualHabilitado = false;
        state.solicitaCodigoPromocion = false;
        state.requiereCodigoPromocion = false;
        state.validaCodigoDuplicado = false;
        state.solicitaNombre = false;
        state.requiereNombre = false;
        state.solicitaDocumento = false;
        state.requiereDocumento = false;
        state.validaDocumentoDuplicado = false;
        state.solicitaDatosPersonales = false;
        state.solicitaTelefono = false;
        state.requiereTelefono = false;
        state.validaTelefonoDuplicado = false;
        state.solicitaEmail = false;
        state.requiereEmail = false;
        state.validaEmailDuplicado = false;
        state.solicitaUbicacion = false;
        state.requiereUbicacion = false;
        state.solicitaLocalidad = false;
        state.requiereLocalidad = false;
        state.solicitaBarrio = false;
        state.requiereBarrio = false;
        state.requiereInformacionBancaria = false;
        state.participacionNegocios = false;
        state.solicitaPosicionNegocio = false;
        state.requierePosicionNegocio = false;
        state.solicitaRazonSocialNegocio = false;
        state.requiereRazonSocialNegocio = false;
        state.solicitaDocumentoNegocio = false;
        state.requiereDocumentoNegocio = false;
        state.validaDocumentoNegocioDuplicado = false;
        state.solicitaUbicacionNegocio = false;
        state.requiereUbicacionNegocio = false;
        state.solicitaLocalidadNegocio = false;
        state.requiereLocalidadNegocio = false;
        state.solicitaBarrioNegocio = false;
        state.requiereBarrioNegocio = false;
        state.importaParticipantes = false;
        state.sorteaGanadores = false;
        state.importaGanadores = false;
        state.validaIdentidad = false;
        state.validaParticipacion = false;
        state.validaImagenes = false;
        state.transferenciasPremios = false;
        state.rowVersion = null;

        state.camposAdicionales = [];
        state.participantesColumnas = [];
    
        state.participantesColumnasList = [];
    },
    'SET_PARTICIPANTES_COLUMNAS' (state, participantesColumnas) {
        state.participantesColumnasList = participantesColumnas;

        state.participantesColumnas = state.participantesColumnasList.map(columna => ({
            participanteColumnaId: columna.id,
            participanteColumna: columna.nombre,
            seleccionada: false,
            orden: 0
        }));
    },
    'SET_EVENTO' (state, evento) {
        state.fechaInicio = moment(evento.fechaInicio).format('YYYY-MM-DD'),
        state.fechaFin = moment(evento.fechaFin).format('YYYY-MM-DD'),
        state.clienteId = evento.cliente? evento.cliente.id : 0;
        state.cliente = evento.cliente;
        state.clienteNombre = evento.cliente? evento.cliente.nombre.trim() : null;
        state.tipoEventoId = evento.tipoEvento? evento.tipoEvento.id : 0;
        state.tipoEvento = evento.tipoEvento;
        state.tipoEventoNombre = evento.tipoEvento? evento.tipoEvento.nombre.trim() : null;
        state.nombre = evento.nombre.trim();
        state.mensajeTexto = evento.mensajeTexto.trim();
        state.mensajeRespuesta = evento.mensajeRespuesta.trim();
        state.sorteoPuestos = evento.sorteoPuestos;
        state.registroManualHabilitado = (/true/i).test(evento.registroManualHabilitado);
        state.solicitaCodigoPromocion = (/true/i).test(evento.solicitaCodigoPromocion);
        state.requiereCodigoPromocion = (/true/i).test(evento.requiereCodigoPromocion);
        state.validaCodigoDuplicado = (/true/i).test(evento.validaCodigoDuplicado);
        state.solicitaNombre = (/true/i).test(evento.solicitaNombre);
        state.requiereNombre = (/true/i).test(evento.requiereNombre);
        state.solicitaDocumento = (/true/i).test(evento.solicitaDocumento);
        state.requiereDocumento = (/true/i).test(evento.requiereDocumento);
        state.validaDocumentoDuplicado = (/true/i).test(evento.validaDocumentoDuplicado);
        state.solicitaDatosPersonales = (/true/i).test(evento.solicitaDatosPersonales); 
        state.solicitaUbicacion = (/true/i).test(evento.solicitaUbicacion);
        state.requiereUbicacion = (/true/i).test(evento.requiereUbicacion);
        state.solicitaLocalidad = (/true/i).test(evento.solicitaLocalidad);
        state.requiereLocalidad = (/true/i).test(evento.requiereLocalidad);
        state.solicitaBarrio = (/true/i).test(evento.solicitaBarrio);
        state.requiereBarrio = (/true/i).test(evento.requiereBarrio);
        state.solicitaTelefono = (/true/i).test(evento.solicitaTelefono);
        state.requiereTelefono = (/true/i).test(evento.requiereTelefono);
        state.validaTelefonoDuplicado = (/true/i).test(evento.validaTelefonoDuplicado);
        state.solicitaEmail = (/true/i).test(evento.solicitaEmail);
        state.requiereEmail = (/true/i).test(evento.requiereEmail);
        state.validaEmailDuplicado = (/true/i).test(evento.validaEmailDuplicado);
        state.requiereInformacionBancaria = (/true/i).test(evento.requiereInformacionBancaria);
        state.participacionNegocios = (/true/i).test(evento.participacionNegocios);
        state.solicitaPosicionNegocio = (/true/i).test(evento.solicitaPosicionNegocio);
        state.requierePosicionNegocio = (/true/i).test(evento.requierePosicionNegocio);
        state.solicitaRazonSocialNegocio = (/true/i).test(evento.solicitaRazonSocialNegocio);
        state.requiereRazonSocialNegocio = (/true/i).test(evento.requiereRazonSocialNegocio);
        state.solicitaDocumentoNegocio = (/true/i).test(evento.solicitaDocumentoNegocio);
        state.requiereDocumentoNegocio = (/true/i).test(evento.requiereDocumentoNegocio);
        state.validaDocumentoNegocioDuplicado = (/true/i).test(evento.validaDocumentoNegocioDuplicado);
        state.solicitaUbicacionNegocio = (/true/i).test(evento.solicitaUbicacionNegocio);
        state.requiereUbicacionNegocio = (/true/i).test(evento.requiereUbicacionNegocio);
        state.solicitaLocalidadNegocio = (/true/i).test(evento.solicitaLocalidadNegocio);
        state.requiereLocalidadNegocio = (/true/i).test(evento.requiereLocalidadNegocio);
        state.solicitaBarrioNegocio = (/true/i).test(evento.solicitaBarrioNegocio);
        state.requiereBarrioNegocio = (/true/i).test(evento.requiereBarrioNegocio);
        state.importaParticipantes = (/true/i).test(evento.importaParticipantes);
        state.sorteaGanadores = (/true/i).test(evento.sorteaGanadores);
        state.importaGanadores = (/true/i).test(evento.importaGanadores);
        state.validaIdentidad = (/true/i).test(evento.validaIdentidad);
        state.validaParticipacion = (/true/i).test(evento.validaParticipacion);
        state.validaImagenes = (/true/i).test(evento.validaImagenes);
        state.transferenciasPremios = (/true/i).test(evento.transferenciasPremios);
        state.rowVersion = evento.rowVersion;

        state.camposAdicionales = evento.camposAdicionales;

        state.participantesColumnas = state.participantesColumnasList.map(columna => ({
            participanteColumnaId: columna.id,
            participanteColumna: columna.nombre,
            seleccionada: false,
            orden: 0
        }));

        evento.participantesColumnas.forEach(participanteColumna => {
            var columna = state.participantesColumnas.find(t => t.participanteColumnaId == participanteColumna.participanteColumnaId);
            if (columna) {
                columna.seleccionada = true;
                columna.orden = participanteColumna.orden;
            }
        });

        state.participantesColumnas = state.participantesColumnas.sort((a, b) => {
            if (a.seleccionada & !b.seleccionada) {
                return -1;
            } else if (!a.seleccionada & b.seleccionada) {
                return 1;
            }

            if (a.orden < b.orden) {
                return -1;
            }
            if (a.orden > b.orden) {
                return 1;
            }
            return 0;
        })
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;
        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
    },
    'SET_TIPO_EVENTO'(state, tipoEvento) {
        let tipoActual = 0;
        let tipoActualizado = 0;
        if (state.tipoEvento) {
            if (state.tipoEvento.id) {
                tipoActual = state.tipoEvento.id;
            }
        }
        if (tipoEvento) {
            if (tipoEvento.id) {
                tipoActualizado = tipoEvento.id;
            }
        }
        
        if (tipoActual != tipoActualizado) {
            state.tipoEvento = tipoEvento;
    
            if (tipoEvento) {
                state.tipoEventoId = tipoEvento.id? tipoEvento.id : 0;
                state.tipoEventoNombre = tipoEvento.nombre? tipoEvento.nombre.trim() : null;
            } else {
                state.tipoEventoId = 0;
                state.tipoEventoNombre = null;
            }
    
            inicializarConfiguracion(state);
        }
    },
    'SELECCIONAR_CAMPO_ADICIONAL'(state, campoAdicional) {
        if (campoAdicional) {
            state.campoAdicional = campoAdicional;
        } else {
            state.campoAdicional = {
                id: 0,
                campo: '',
                obligatorio: false,
                validaDuplicado: false,
                incluirListado: false
            };
        }
    },
    'SAVE_CAMPO_ADICIONAL'(state, campoAdicional) {
        if (state.campoAdicional.id == 0) {
            state.camposAdicionales.push(campoAdicional);
        } else {
            state.campoAdicional.campo = campoAdicional.campo;
            state.campoAdicional.obligatorio = (/true/i).test(campoAdicional.obligatorio);
            state.campoAdicional.validaDuplicado = (/true/i).test(campoAdicional.validaDuplicado);
            state.campoAdicional.incluirListado = (/true/i).test(campoAdicional.incluirListado);
        }
    },
    'DELETE_CAMPO_ADICIONAL'(state, campoAdicional) {
        let itemKey = state.camposAdicionales
            .findIndex(t => t == campoAdicional);

        if (itemKey != -1) {
            state.camposAdicionales.splice(itemKey, 1);
        }
    },

    // 'INICIALIZAR_PARTICIPANTES_IMPORTADOS'(state) {
    //     state.participantesImportados = 0;
    // },
    // 'SET_PARTICIPANTES_IMPORTADOS'(state, participantes) {
    //     state.participantesImportados = participantes;
    // },
    'INICIALIZAR_IMPORT'(state) {
        state.importParticipantesId = 0;
        state.participantesImportados = 0;
    },
    'SET_IMPORT'(state, result) {
        console.log(result);
        state.importParticipantesId = result.importParticipantesId;
        state.participantesImportados = result.participantesImportados;
    },
};

function inicializarConfiguracion(state) {
    // console.log('inicializarConfiguracion');
    state.mensajeTexto = '';
    state.mensajeRespuesta = '';
    state.sorteoPuestos = 0;
    state.registroManualHabilitado = false;
    state.solicitaCodigoPromocion = false;
    state.requiereCodigoPromocion = false;
    state.validaCodigoDuplicado = false;
    state.solicitaNombre = false;
    state.requiereNombre = false;
    state.solicitaDocumento = false;
    state.requiereDocumento = false;
    state.validaDocumentoDuplicado = false;
    state.solicitaDatosPersonales = false;
    state.solicitaTelefono = false;
    state.requiereTelefono = false;
    state.validaTelefonoDuplicado = false;
    state.solicitaEmail = false;
    state.requiereEmail = false;
    state.validaEmailDuplicado = false;
    state.solicitaUbicacion = false;
    state.requiereUbicacion = false;
    state.solicitaLocalidad = false;
    state.requiereLocalidad = false;
    state.solicitaBarrio = false;
    state.requiereBarrio = false;
    state.requiereInformacionBancaria = false;
    state.participacionNegocios = false;
    state.solicitaPosicionNegocio = false;
    state.requierePosicionNegocio = false;
    state.solicitaRazonSocialNegocio = false;
    state.requiereRazonSocialNegocio = false;
    state.solicitaDocumentoNegocio = false;
    state.requiereDocumentoNegocio = false;
    state.validaDocumentoNegocioDuplicado = false;
    state.solicitaUbicacionNegocio = false;
    state.requiereUbicacionNegocio = false;
    state.solicitaLocalidadNegocio = false;
    state.requiereLocalidadNegocio = false;
    state.solicitaBarrioNegocio = false;
    state.requiereBarrioNegocio = false;
    state.importaParticipantes = false;
    state.sorteaGanadores = false;
    state.importaGanadores = false;
    state.validaIdentidad = false;
    state.validaParticipacion = false;
    state.validaImagenes = false;
    state.transferenciasPremios = false;
}

const getters = {
    getField,

    importParticipantesId (state) {
        return state.importParticipantesId;
    },
    participantesImportados (state) {
        return state.participantesImportados;
    }
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO', eventoId);

            if (eventoId != 0) {
                /* Recuperamos la lista de columnas */
                apiAxios.get('participantes-columnas/list') 
                    .then (res => {
                        commit('SET_PARTICIPANTES_COLUMNAS', res.data);
                        /* Recuperamos los datos del evento */
                        return apiAxios.get(`eventos/${eventoId}/abm` );
                    })
                    .then(res => {
                        commit('SET_EVENTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                /* Recuperamos la lista de columnas */
                apiAxios.get('participantes-columnas/list') 
                    .then (res => {
                        commit('SET_PARTICIPANTES_COLUMNAS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let solicitaCodigoPromocion = (/true/i).test(state.solicitaCodigoPromocion);
                let requiereCodigoPromocion = (/true/i).test(state.requiereCodigoPromocion);
                let validaCodigoDuplicado = (/true/i).test(state.validaCodigoDuplicado);
                if (solicitaCodigoPromocion == false) {
                    requiereCodigoPromocion = false;
                    validaCodigoDuplicado = false;
                }

                let solicitaNombre = (/true/i).test(state.solicitaNombre);
                let requiereNombre = (/true/i).test(state.requiereNombre);
                if (solicitaNombre == false) {
                    requiereNombre = false;
                }

                let solicitaDocumento = (/true/i).test(state.solicitaDocumento);
                let requiereDocumento = (/true/i).test(state.requiereDocumento);
                let validaDocumentoDuplicado = (/true/i).test(state.validaDocumentoDuplicado);
                if (solicitaDocumento == false) {
                    requiereDocumento = false;
                    validaDocumentoDuplicado = false;
                }

                let solicitaTelefono = (/true/i).test(state.solicitaTelefono);
                let requiereTelefono = (/true/i).test(state.requiereTelefono);
                let validaTelefonoDuplicado = (/true/i).test(state.validaTelefonoDuplicado);
                if (solicitaTelefono == false) {
                    requiereTelefono = false;
                    validaTelefonoDuplicado = false;
                }

                let solicitaEmail = (/true/i).test(state.solicitaEmail);
                let requiereEmail = (/true/i).test(state.requiereEmail);
                let validaEmailDuplicado = (/true/i).test(state.validaEmailDuplicado);
                if (solicitaEmail == false) {
                    requiereEmail = false;
                    validaEmailDuplicado = false;
                }

                let solicitaUbicacion = (/true/i).test(state.solicitaUbicacion);
                let requiereUbicacion = (/true/i).test(state.requiereUbicacion);
                let solicitaLocalidad = false;
                let requiereLocalidad = false;
                let solicitaBarrio = false;
                let requiereBarrio = false;
                if (solicitaUbicacion == false) {
                    requiereUbicacion = false;
                } else {
                    solicitaLocalidad = (/true/i).test(state.solicitaLocalidad);
                    if (solicitaLocalidad) {
                        requiereLocalidad = (/true/i).test(state.requiereLocalidad);
                    }

                    solicitaBarrio = (/true/i).test(state.solicitaBarrio);
                    if (solicitaBarrio) {
                        requiereBarrio = (/true/i).test(state.requiereBarrio);
                    }
                }

                let participacionNegocios = (/true/i).test(state.participacionNegocios);
                let solicitaRazonSocialNegocio = (/true/i).test(state.solicitaRazonSocialNegocio);
                let requiereRazonSocialNegocio = (/true/i).test(state.requiereRazonSocialNegocio);
                let solicitaDocumentoNegocio = (/true/i).test(state.solicitaDocumentoNegocio);
                let requiereDocumentoNegocio = (/true/i).test(state.requiereDocumentoNegocio);
                let validaDocumentoNegocioDuplicado = (/true/i).test(state.validaDocumentoNegocioDuplicado);
                let solicitaUbicacionNegocio = (/true/i).test(state.solicitaUbicacionNegocio);
                let requiereUbicacionNegocio = (/true/i).test(state.requiereUbicacionNegocio);
                let solicitaPosicionNegocio = false;
                let requierePosicionNegocio = false;
                let solicitaLocalidadNegocio = false;
                let requiereLocalidadNegocio = false;
                let solicitaBarrioNegocio = false;
                let requiereBarrioNegocio = false;
                if (participacionNegocios) {
                    if (solicitaDocumentoNegocio == false) {
                        requiereDocumentoNegocio = false;
                        validaDocumentoNegocioDuplicado = false;
                    }
                    if (solicitaUbicacionNegocio == false) {
                        requiereUbicacionNegocio = false;
                    } else {
                        solicitaPosicionNegocio = (/true/i).test(state.solicitaPosicionNegocio);
                        if (solicitaPosicionNegocio) {
                            requierePosicionNegocio = (/true/i).test(state.requierePosicionNegocio);
                        }

                        solicitaLocalidadNegocio = (/true/i).test(state.solicitaLocalidadNegocio);
                        if (solicitaLocalidadNegocio) {
                            requiereLocalidadNegocio = (/true/i).test(state.requiereLocalidadNegocio);
                        }
    
                        solicitaBarrioNegocio = (/true/i).test(state.solicitaBarrioNegocio);
                        if (solicitaBarrioNegocio) {
                            requiereBarrioNegocio = (/true/i).test(state.requiereBarrioNegocio);
                        }
                    }
                } else {
                    solicitaRazonSocialNegocio = false;
                    requiereRazonSocialNegocio = false;
                    solicitaDocumentoNegocio = false;
                    requiereDocumentoNegocio = false;
                    validaDocumentoNegocioDuplicado = false;
                    solicitaUbicacionNegocio = false;
                    requiereUbicacionNegocio = false;
                }

                let participantesColumnas = state.participantesColumnas
                    .filter(t => t.seleccionada)
                    .map(columna => ({
                        participanteColumnaId: columna.participanteColumnaId,
                        orden: columna.orden
                    }));

                let evento= {
                    fechaInicio: moment(state.fechaInicio).format('YYYY-MM-DD'),
                    fechaFin: moment(state.fechaFin).format('YYYY-MM-DD'),
                    clienteId: parseInt(state.clienteId),
                    tipoEventoId: parseInt(state.tipoEventoId),
                    nombre: state.nombre.toUpperCase().trim(),
                    mensajeTexto: state.mensajeTexto.trim(),
                    mensajeRespuesta: state.mensajeRespuesta.trim(),
                    sorteoPuestos: parseInt(state.sorteoPuestos),
                    registroManualHabilitado: (/true/i).test(state.registroManualHabilitado),
                    solicitaCodigoPromocion,
                    requiereCodigoPromocion,
                    validaCodigoDuplicado,
                    solicitaNombre,
                    requiereNombre,
                    solicitaDocumento,
                    requiereDocumento,
                    validaDocumentoDuplicado,
                    solicitaDatosPersonales: (/true/i).test(state.solicitaDatosPersonales),
                    solicitaTelefono,
                    requiereTelefono,
                    validaTelefonoDuplicado,
                    solicitaEmail,
                    requiereEmail,
                    validaEmailDuplicado,
                    solicitaUbicacion,
                    requiereUbicacion,
                    solicitaLocalidad,
                    requiereLocalidad,
                    solicitaBarrio,
                    requiereBarrio,
                    requiereInformacionBancaria: (/true/i).test(state.requiereInformacionBancaria),
                    participacionNegocios,
                    solicitaPosicionNegocio,
                    requierePosicionNegocio,
                    solicitaRazonSocialNegocio,
                    requiereRazonSocialNegocio,
                    solicitaDocumentoNegocio,
                    requiereDocumentoNegocio,
                    validaDocumentoNegocioDuplicado,
                    solicitaUbicacionNegocio,
                    requiereUbicacionNegocio,
                    solicitaLocalidadNegocio,
                    requiereLocalidadNegocio,
                    solicitaBarrioNegocio,
                    requiereBarrioNegocio,
                    importaParticipantes: (/true/i).test(state.importaParticipantes),
                    sorteaGanadores: (/true/i).test(state.sorteaGanadores),
                    importaGanadores: (/true/i).test(state.importaGanadores),
                    validaIdentidad: (/true/i).test(state.validaIdentidad),
                    validaParticipacion: (/true/i).test(state.validaParticipacion),
                    validaImagenes: (/true/i).test(state.validaImagenes),
                    transferenciasPremios: (/true/i).test(state.transferenciasPremios),
                    camposAdicionales: state.camposAdicionales,
                    participantesColumnas
                };

                let url = 'eventos';
                if (state.id != 0) {
                    url += '/' + state.id;
                    evento.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, evento)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },
    setTipoEvento: ({commit}, tipoEvento) => {
        commit('SET_TIPO_EVENTO', tipoEvento);
    },
    sendSMS ( {}, params ) {
        return new Promise((resolve, reject) => { 
          apiAxios.post('eventos/sms', params)
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    seleccionarCampoAdicional: ({commit}, campoAdicional) => {
        commit('SELECCIONAR_CAMPO_ADICIONAL', campoAdicional);
    },
    saveCampoAdicional: ({commit}, campoAdicional) => {
        commit('SAVE_CAMPO_ADICIONAL', campoAdicional);
    },
    deleteCampoAdicional: ({commit}, campoAdicional) => {
        commit('DELETE_CAMPO_ADICIONAL', campoAdicional);
    },

    importarParticipantes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMPORT');

            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'csv') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten archivos de tipo csv.';
            }

            if (fileSize >= 5 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten archivos de hasta 5MB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post(`eventos/${params.eventoId}/participantes/import`, formData, options)
                    .then(res => {
                        commit('SET_IMPORT', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}